import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

export class Map {

    constructor ( target = '.js-map', key = '', options = {} ) {
        this.target = target;
        this.key = key;

        this.options = {
            ...options
        }
    }

    init () {
        mapboxgl.accessToken = 'pk.eyJ1Ijoicm9vdHN0dWRpbyIsImEiOiJja2w5ZHo3dW8wbXdiMnhuMGY5ZmlzenY0In0.ZffNaZivXrlt3h3HX6xg2Q'

        this.$container = document.querySelector( this.target );
        this.$carousel = document.querySelector('.js-carousel');

        if ( !this.$container ) {
            return false;
        }

        if ( this.$carousel && this.$carousel.dataset.multiple ) {
            this.createMultiple();

            this.map.scrollZoom.disable();
            const nav = new mapboxgl.NavigationControl();
            this.map.addControl( nav, 'bottom-right' );
        } else {
            this.createSingleMarker();

            this.map.scrollZoom.disable();
            const nav = new mapboxgl.NavigationControl();
            this.map.addControl( nav, 'bottom-right' );
        }
    }

    createMultiple() {
        this.$container = document.querySelectorAll( this.target );
        
        this.$container.forEach( ( container ) => {
            const center = [
                container.dataset.lng,
                container.dataset.lat,
            ]

            const zoom = container.dataset.zoom;

            this.map = new mapboxgl.Map({
                container: container,
                style: 'mapbox://styles/rootstudio/cl8tztlrg008w14rs8ujfrx9l',
                center,
                zoom: zoom,
                attributionControl: false,
                
            });

            const el = document.createElement( 'div' );
            el.className = 'marker';
            el.style.backgroundImage = 'url("/assets/map-icon.svg")';
            el.style.width = '60px';
            el.style.height = '70px';
            el.style.backgroundSize = '100%';

            // Create a new marker for each map
            const marker = new mapboxgl.Marker( el )
            .setLngLat( center )
            .addTo( this.map );
        });
    }

    createSingleMarker () {
        const center = [
            this.$container.dataset.lng,
            this.$container.dataset.lat,
        ]

        const zoom = this.$container.dataset.zoom

        this.map = new mapboxgl.Map( {
            container: this.$container,
            style: 'mapbox://styles/rootstudio/cl8tztlrg008w14rs8ujfrx9l',
            center,
            zoom: zoom,
            attributionControl: false
        } );

        const el = document.createElement( 'div' );
        el.className = 'marker';
        el.style.backgroundImage = 'url("/assets/map-icon.svg")';
        el.style.width = '60px';
        el.style.height = '70px';
        el.style.backgroundSize = '100%';

        const marker = new mapboxgl.Marker( el )
        .setLngLat( center )
        .addTo( this.map );
    }

}